import ActionTypes, { TDataShowUsers, TDataToCheck, TUsersState } from './types';
import { Actions, TDefRequest } from '../Action';
import { action } from 'typesafe-actions';

export const UsersActions = {
  setError: (payload: TUsersState['error']) => action(ActionTypes.SET_ERROR, payload),
  setUser: (payload: TUsersState['user']) => action(ActionTypes.CHECK_USER_S, payload),
  setUsers: (payload: TUsersState['users']) => action(ActionTypes.SHOW_USERS_S, payload),
  setIsAuth: (payload: TUsersState['isAuth']) => action(ActionTypes.SET_IS_AUTH, payload),
};

const CheckUserAction = new Actions('CHECK_USER', ActionTypes);
const ShowUsersAction = new Actions('SHOW_USERS', ActionTypes);

export interface TypeChekUserR extends TDefRequest {
  data: TDataToCheck;
}

export interface TypeShowUsersR extends TDefRequest {
  data: TDataShowUsers;
}

export const CheckUser = {
  request: (payload: TypeChekUserR) => CheckUserAction.request(payload),
  success: (payload: TUsersState['user']) => CheckUserAction.success(payload || {}),
  error: (message: string) => CheckUserAction.error(message),
};

export const ShowUsers = {
  request: (payload: TypeShowUsersR) => ShowUsersAction.request(payload),
  success: (payload: TUsersState['users']) => ShowUsersAction.success(payload || {}),
  error: (message: string) => ShowUsersAction.error(message),
};
